/**
 * Consent notice for the auth pages. "By continuing" deliberately covers
 * every account-creating action on the page — the email "Create account"
 * submit AND "Continue with Google", which creates an account on first use
 * (including from the Login page). Shown on both Signup and Login so a
 * brand-new user can't create an account without seeing the terms.
 *
 * Links open the live legal pages on the marketing site in a new tab.
 */

const TERMS_URL = 'https://remindmevoice.com/terms';
const PRIVACY_URL = 'https://remindmevoice.com/privacy';

export function AuthConsentNotice() {
  return (
    <p className="mt-4 text-xs text-ink-muted">
      By continuing, you agree to our{' '}
      <a
        href={TERMS_URL}
        target="_blank"
        rel="noreferrer"
        className="text-accent-600 underline hover:no-underline"
      >
        Terms of Service
      </a>{' '}
      and{' '}
      <a
        href={PRIVACY_URL}
        target="_blank"
        rel="noreferrer"
        className="text-accent-600 underline hover:no-underline"
      >
        Privacy Policy
      </a>
      .
    </p>
  );
}
